<template>
  <div>
<!--    <div style="display: flex">-->
<!--      <div id="dataChart1" style="width: 50%;height:80vh"></div>-->
<!--      <div id="dataChart" style="width: 50%;height:80vh;margin-top: 20px"></div>-->
<!--    </div>-->
<!--    <FacebookLoader></FacebookLoader>-->
    <iframe src="https://www.jmi-cloud.com/index.html" frameborder="0" width="100%" height="100%" style="height: 100vh"></iframe>
  </div>
</template>

<script>
  import axios from 'axios';
  import echarts from 'echarts/index';
  import {FacebookLoader} from 'vue-content-loader'
  export default {
    name: "index",
    data(){
      return {
      }
    },
    components:{
      FacebookLoader
    },
    mounted() {
      var me = this;
      me.getData();
      me.getData1();
    },
    methods:{
      getData(){
        var me = this;
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('dataChart'));
        var dataAxis = ['点', '击', '柱', '子', '或', '者', '两', '指', '在', '触', '屏', '上', '滑', '动', '能', '够', '自', '动', '缩', '放'];
        var data = [220, 182, 191, 234, 290, 330, 310, 123, 442, 321, 90, 149, 210, 122, 133, 334, 198, 123, 125, 220];
        var yMax = 500;
        var dataShadow = [];

        for (var i = 0; i < data.length; i++) {
          dataShadow.push(yMax);
        }

        let option = {
          title: {
            text: '业务概览',
            subtext: 'Feature Sample: Gradient Color, Shadow, Click Zoom'
          },
          xAxis: {
            data: dataAxis,
            axisLabel: {
              inside: true,
              textStyle: {
                color: '#fff'
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            z: 10
          },
          yAxis: {
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#999'
              }
            }
          },
          dataZoom: [
            {
              type: 'inside'
            }
          ],
          series: [
            { // For shadow
              type: 'bar',
              itemStyle: {
                color: 'rgba(0,0,0,0.05)'
              },
              barGap: '-100%',
              barCategoryGap: '40%',
              data: dataShadow,
              animation: false
            },
            {
              type: 'bar',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                    {offset: 0, color: '#83bff6'},
                    {offset: 0.5, color: '#188df0'},
                    {offset: 1, color: '#188df0'}
                  ]
                )
              },
              emphasis: {
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset: 0, color: '#2378f7'},
                      {offset: 0.7, color: '#2378f7'},
                      {offset: 1, color: '#83bff6'}
                    ]
                  )
                }
              },
              data: data
            }
          ]
        };

        var zoomSize = 6;
        myChart.on('click', function (params) {
          console.log(dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)]);
          myChart.dispatchAction({
            type: 'dataZoom',
            startValue: dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)],
            endValue: dataAxis[Math.min(params.dataIndex + zoomSize / 2, data.length - 1)]
          });
        });

        myChart.setOption(option);
      },
      getData1() {
        var me = this;
        var myChart = echarts.init(document.getElementById('dataChart1'));
        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            data: ['利润', '支出', '收入']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'value'
            }
          ],
          yAxis: [
            {
              type: 'category',
              axisTick: {
                show: false
              },
              data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
            }
          ],
          series: [
            {
              name: '利润',
              type: 'bar',
              label: {
                show: true,
                position: 'inside'
              },
              data: [200, 170, 240, 244, 200, 220, 210]
            },
            {
              name: '收入',
              type: 'bar',
              stack: '总量',
              label: {
                show: true
              },
              data: [320, 302, 341, 374, 390, 450, 420]
            },
            {
              name: '支出',
              type: 'bar',
              stack: '总量',
              label: {
                show: true,
                position: 'left'
              },
              data: [-120, -132, -101, -134, -190, -230, -210]
            }
          ]
        };
        myChart.setOption(option);
      }
    }
  }
</script>

<style scoped>

</style>